﻿import MuiMenu from '@material-ui/core/Menu';
import MuiMenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import MMoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import { IconButton } from '../';
import { BLACK_GREY, HIGHLIGHT } from '../Colors';
import { BODY } from '../Fonts';
import { IMenuColumn } from './Table';

const StyledMenu = withStyles({
    paper: {
        backgroundColor: BLACK_GREY
    },
    list: {
        padding: 0
    },
})(MuiMenu);

const StyledMenuItem = withStyles({
    root: {
        font: BODY,
        color: '#FFFFFF',
        '&:hover': {
            backgroundColor: HIGHLIGHT
        }
    },
})(MuiMenuItem);

interface ITableBodyCellContentMenuProps {
    row: any;
    column: IMenuColumn;
}

export const TableBodyCellContentMenu: React.FunctionComponent<ITableBodyCellContentMenuProps> = (props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const onClick = (item: { label: string, onClick: (row: any) => void }) => {
        setAnchorEl(null);
        item.onClick(props.row);
    }

    return (<div>
        <IconButton type="secondary" onClick={event => { setAnchorEl(event.currentTarget); event.stopPropagation(); }}>
            <MMoreVertIcon />
        </IconButton>
        <StyledMenu open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
            {props.column.menuItems.map((item, i) => (<StyledMenuItem key={i} onClick={() => onClick(item)}>{item.label}</StyledMenuItem>))}
        </StyledMenu>
    </div>);
}